import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Checkbox from 'dpl/common/design_system/Checkbox';
import Icon from 'dpl/common/components/Icon';

const COMMON_CLASSNAMES = 'grid grid-cols-1 gap-y-16';

export default function ExpandableChecklist({
  className,
  checklistName,
  options,
  seeMoreAfter,
  onChange,
  values
}) {
  const [isShowingMore, setIsShowingMore] = useState(false);

  function renderOptionsComponent(opts) {
    return opts.map(opt => {
      if (opt.label) {
        return (
          <p key={opt.label} className="font-14 fw-medium mb6">
            {opt.label}
          </p>
        );
      }

      const { title, value } = opt;

      return (
        <Checkbox
          key={value}
          id={`${checklistName}_${value}`}
          name={title}
          title={title}
          value={value}
          label={title}
          checked={values.includes(value)}
          onChange={onChange}
        />
      );
    });
  }

  function renderShowMoreButton() {
    const [text, iconName] = isShowingMore
      ? ['Show less', 'fetch-chevron-up']
      : ['Show more', 'fetch-chevron-down'];

    return (
      <div className="flex items-center">
        <p className="stone-700 font-16 underline fw-medium">{text}</p>
        <Icon name={iconName} height="16px" />
      </div>
    );
  }

  const shouldShowMore = seeMoreAfter > 0 && seeMoreAfter < options.length;

  return (
    <>
      {shouldShowMore ? (
        <>
          <div className={classnames(COMMON_CLASSNAMES, className)}>
            {renderOptionsComponent(options.slice(0, seeMoreAfter))}
            {isShowingMore &&
              renderOptionsComponent(options.slice(seeMoreAfter))}
          </div>
          <button
            type="button"
            onClick={() => setIsShowingMore(!isShowingMore)}
          >
            {renderShowMoreButton()}
          </button>
        </>
      ) : (
        <div className={classnames(COMMON_CLASSNAMES, className)}>
          {renderOptionsComponent(options)}
        </div>
      )}
    </>
  );
}

ExpandableChecklist.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired
      }),
      PropTypes.shape({ label: PropTypes.string }).isRequired
    ])
  ).isRequired,
  checklistName: PropTypes.string.isRequired,
  seeMoreAfter: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired
};

ExpandableChecklist.defaultProps = {
  className: '',
  seeMoreAfter: 0
};
